import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reportes/rinventario';
import RInventario from './RInventario';

const mstp = state => {
    return {...state.rinventario}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(RInventario)
